import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import {
  createRole,
  getRoleById,
  updateRole,
} from "../../../../services/RoleService";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditRole = () => {
  const [role, setRole] = useState({
    label: "",
    number: "",
    slug: ""
  });
  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch role data when component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getRoleById(id);
        setRole(data);
      } catch (error) {
        console.error("Error fetching role:", error);
      }
    };
    fetchData();
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Send the form data to the server
    try {
      await updateRole(id, {
        label: role.label,
        number: role.number,
        slug: role.slug,
      });
      // Show success toast notification
      toast.success("Role updated Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 2 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/roles");
      }, 3000);
    } catch (error) {
      console.error("Error in role update:", error);
      toast.error("Failed to Update Role!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(`Field Name: ${name}, Field Value: ${value}`); // Debugging
    setRole({ ...role, [name]: value });
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col xs={12}>
              <h4>Edit Role</h4>
              {role ? (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3 mt-3">
                    <Col md={3}>
                      <Form.Group controlId="label">
                        <Form.Label>Label</Form.Label>
                        <Form.Control
                          type="text"
                          name="label"
                          value={role.label || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="number">
                        <Form.Label>Number</Form.Label>
                        <Form.Control
                          type="number"
                          name="number"
                          value={role.number || ""}
                          onChange={handleChange}
                          min="1"
                          placeholder="Number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="slug">
                        <Form.Label>Slug</Form.Label>
                        <Form.Control
                          type="text"
                          name="slug"
                          value={role.slug || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <div className="d-flex">
                      <Button className="me-2" variant="primary" type="submit">
                        Save Changes
                      </Button>
                      <Button className="btn-danger" variant="warning" href="/settings/roles">
                        Cancel
                      </Button>
                    </div>
                  </Row>
                </Form>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      </Card>
      <ToastContainer />
    </>
  );
};

export default EditRole;
